/*
 *
 * Confirm Account
 *
 */

import "./styles.scss";

import { API, Endpoints } from "utils/api";
import { Checkbox, Select, notification } from "antd";
import { setLoader, setPagesModal, setToken, setUser } from "store/actions";

import { Footer } from "screens";
import { Helmet } from "react-helmet";
import Password from "components/Password";
import React from "react";
import { RotateSpinner } from "react-spinners-kit";
import Strings from "utils/strings";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import strings from "utils/strings";

export class DefinePassword extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			password: "",
			showPassword: false,
			acceptedTerms: false,
			marketingEmail: false,
			languageOptions: [],
			isPasswordValid: false,

			confirming: false,
			isMobile: window.innerWidth <= 768
		};

		this.handleResize = this.handleResize.bind(this);
		window.addEventListener("resize", this.handleResize);
	}

	componentDidMount() {
		const {
			match: {
				params: { email, code }
			},
			dispatch
		} = this.props;

		if (!email || !code) {
			dispatch(push("/login"));
			return;
		}

		this.getLanguageOptions();

		this.handleResize();
	}

	async getLanguageOptions() {
		try {
			const response = await API.get({
				url: Endpoints.uriLanguages()
			});

			if (response.ok) {
				const { languages } = response?.data?.results;
				this.setState({ languageOptions: languages || [] });
			} else {
				notification.error({
					message: Strings.sidebar.profile,
					description: Strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: Strings.sidebar.profile,
				description: Strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	handleResize() {
		this.setState({ isMobile: window.innerWidth <= 768 });
	}

	async setPassword() {
		const { password, acceptedTerms, marketingEmail, language } = this.state;
		const {
			match: {
				params: { email, code }
			},
			dispatch,
			isPsychologist
		} = this.props;

		if (!acceptedTerms) {
			return notification.warn({
				message: strings.authentication.header,
				description: strings.authentication.acceptance,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.post({
				url: isPsychologist
					? Endpoints.uriPsychologistsConfirmAccount(code)
					: Endpoints.uriUsersConfirmAccount(code),
				data: {
					email,
					password,
					marketingEmail,
					language
				}
			});

			if (response.ok) {
				const { user, psychologist, token } = response.data.results || {};
				if (isPsychologist) {
					dispatch(setUser(psychologist));
				} else {
					dispatch(setUser(user));
				}
				dispatch(setToken(token));

				notification.success({
					message: strings.authentication.header,
					description: strings.authentication.accountConfirmed,
					placement: "bottomRight",
					duration: 5
				});
			} else {
				notification.error({
					message: strings.authentication.header,
					description: response?.data?.message || strings.serverErrors.requestNotPossible,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err) {
			notification.error({
				message: strings.authentication.header,
				description: response?.data?.message || strings.serverErrors.requestNotPossible,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	render() {
		const {
			confirming,
			password,
			showPassword,
			acceptedTerms,
			marketingEmail,
			language,
			languageOptions,
			isPasswordValid
		} = this.state;
		const { isPsychologist, dispatch, mobile } = this.props;

		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.authentication.definePassword}</title>
					<meta name="description" content="Define a password for your account" />
				</Helmet>
				<div className="DefinePasswordContent">
					<div className="DefinePasswordContentWrapper">
						<div className="LoginBox">
							<div className="LoginWelcome" />
							<div className="LoginWrapper">
								<div className="LoginBackground" />
								<div className="LoginForm">
									<h1>{Strings.authentication.definePassword}</h1>
									<h3 className="DefinePasswordSubtitle">
										{Strings.authentication.definePassword2}
									</h3>
									<form
										className="DefinePasswordForm"
										onSubmit={(e: any) => {
											console.log("SUBBMITING");
											e.preventDefault();

											if (!confirming) {
												this.setPassword();
											}
										}}
									>
										<Password
											className="LoginInputClass"
											password={password}
											showPassword={showPassword}
											placeholder={Strings.authentication.password}
											onPasswordChange={(newPassword: string, isValid: boolean) => {
												this.setState({ password: newPassword, isPasswordValid: isValid });
											}}
											onShowPasswordChange={(value: boolean) =>
												this.setState({ showPassword: value })
											}
										/>
										{!isPsychologist && (
											<Select
												id="profile_language"
												optionFilterProp="children"
												className="ant-select-password DefinePasswordLanguageSelect"
												allowClear
												showSearch
												placeholder={Strings.profile.noLanguage}
												value={language || null}
												onChange={(value: any) => this.setState({ language: value })}
											>
												{languageOptions.map((lang: any) => (
													<Select.Option value={lang._id} key={`language_${lang._id}`}>
														{lang.name}
													</Select.Option>
												))}
											</Select>
										)}
										<div className="DefinePasswordLanguageNote">{Strings.profile.languageNote}</div>
										<div className="FormCheckboxes">
											<Checkbox
												checked={acceptedTerms}
												onChange={(e: any) => {
													const value = e.target.checked;
													this.setState({ acceptedTerms: value });
												}}
											>
												<span>{Strings.authentication.acceptTerms} </span>
												<p
													className="FormFakeLink"
													onClick={(e: any) => {
														e.preventDefault();
														e.stopPropagation();
														dispatch(setPagesModal("tc"));
													}}
												>
													{Strings.sidebar.terms}
												</p>
												<span> {Strings.authentication.acceptTerms2} </span>
												<p
													className="FormFakeLink"
													onClick={(e: any) => {
														e.preventDefault();
														e.stopPropagation();
														dispatch(setPagesModal("pp"));
													}}
												>
													{Strings.sidebar.privacy}
												</p>
											</Checkbox>
											{!isPsychologist ? (
												<Checkbox
													checked={marketingEmail}
													onChange={(e: any) => {
														const value = e.target.checked;
														this.setState({ marketingEmail: value });
													}}
												>
													<span>{Strings.authentication.acceptEmailContent}</span>
												</Checkbox>
											) : null}
										</div>
										<button
											type="submit"
											className="LoginButtonClass DefinePasswordSubmitButton"
											disabled={!password || !isPasswordValid}
										>
											{confirming ? (
												<div className="LoadingSpinner">
													<RotateSpinner size={24} color="#FFFFFF" />
												</div>
											) : (
												Strings.generic.confirm
											)}
										</button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
				{mobile && <Footer />}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	user: state.user,
	mobile: state.mobile
});

export default connect(mapStateToProps)(DefinePassword);
